import { Outlet } from 'react-router';

import { Navigate } from '@sorare/routing';
import { PageHeader } from '@sorare/core/src/components/navigation/PageHeader';
import { ANY_SPORT_PLAY } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useIsDesktopAndAbove } from '@sorare/core/src/hooks/device/useIsDesktopAndAbove';
import { useEnableSorare27Nav } from '@sorare/core/src/hooks/useEnableSorare27Nav';
import { navLabels } from '@sorare/core/src/lib/glossary';
import { RequireAuth } from '@sorare/core/src/routing/RequireAuth';

const Layout = () => {
  const { generateSportContextPath } = useSportContext();
  const isDesktopAndAbove = useIsDesktopAndAbove();
  const enableSorare27Nav = useEnableSorare27Nav();
  if (enableSorare27Nav) {
    return (
      <Navigate
        to={generateSportContextPath(ANY_SPORT_PLAY)}
        replace
        keepSearchParams
      />
    );
  }
  return (
    <RequireAuth>
      {!isDesktopAndAbove && (
        <PageHeader text={navLabels.home} disableBackBrowser />
      )}
      <Outlet />
    </RequireAuth>
  );
};

export default Layout;
